import { map, publishLast, refCount } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserialize } from 'santee-dcts';
import { Observable } from 'rxjs';

import { UserPermissions, UserStudyPermissionsReadModel, UserPermissionsReadModel, UserStudyPermissions } from './user-permissions';
import { Settings } from '../core';

@Injectable()
export class UserPermissionsStorage {
    public userPermissions: Observable<UserPermissions>;
    public userStudiesPermissions: Observable<UserStudyPermissions>;

    constructor(private settings: Settings, private http: HttpClient) {
        this.userPermissions = this.loadUserPermissions();
        this.userStudiesPermissions = this.loadUserStudiesPermissions();
    }

    public getPermissionsByStudy(protocolId: number): Observable<UserPermissions> {
        return this.userStudiesPermissions.pipe(
            map((permissions) => permissions[protocolId.toString()] || new UserPermissions([]))
        );
    }

    private loadUserStudiesPermissions(): Observable<UserStudyPermissions> {
        return this.http
            .get(`${this.settings.apiUrl}/user-permissions/studies`)
            .pipe(
                map((rawPermissions) => deserialize(rawPermissions, UserStudyPermissionsReadModel).studyPermissions),
                publishLast(),
                refCount()
            );
    }

    private loadUserPermissions(): Observable<UserPermissions> {
        return this.http
            .get(`${this.settings.apiUrl}/user-permissions`)
            .pipe(
                map(rawPermissions => deserialize(rawPermissions, UserPermissionsReadModel).permissions),
                publishLast(),
                refCount()
            );
    }
}